import Box from "@mui/material/Box";
import Hidden from "@mui/material/Hidden";
import { useI18n } from "@/i18n/I18nProvider";
import { getContactUaeText } from "../../../locales/contact-uae";

export default function Banner() {
  const { t, locale } = useI18n();
  const contactUaeText = getContactUaeText(locale);

  return (
    <>
      <Box sx={{ color: "white", width: "100%", backgroundSize: "cover" }}>
        <Hidden smUp>
          <Box
            component="img"
            src={
              locale === "en"
                ? "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/UAE-mobile-2-english.jpg"
                : "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/UAE-mobile-2-arabic.jpg"
            }
            alt="Banner UAE"
            width="100%"
            height="100%"
            loading="lazy"
            sx={{ display: "block" }}
          />
        </Hidden>

        <Hidden smDown>
          <Box
            component="img"
            src={
              locale === "en"
                ? "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/UAE-Banner-2-English.png"
                : "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/UAE-Banner-2-Arabic.png"
            }
            alt="Banner UAE"
            width="100%"
            height="100%"
            loading="lazy"
            sx={{ display: "block" }}
          />
        </Hidden>
      </Box>

      {/* باقي المحتوى كما هو */}
      <Box
        className="horizontal-safe-padding vertical-safe-padding"
        sx={{ backgroundColor: "#FFFFFF", textAlign: { sm: "center" } }}
      >
        <Box sx={{ py: { md: 5 } }}>
          <Box
            sx={{
              "& h1": {
                fontWeight: 700,
                fontSize:
                  locale === "en"
                    ? { xs: "16px", sm: "32px" }
                    : { xs: "20px", sm: "32px" },
                color: "#2D317F",
                margin: 0,
              },
              "& h2": {
                fontWeight: 700,
                fontSize:
                  locale === "en"
                    ? { xs: "16px", sm: "32px" }
                    : { xs: "20px", sm: "32px" },
                color: "#2D317F",
                margin: 0,
              },
            }}
          >
            {contactUaeText.banner.title}
          </Box>

          <Box
            component="img"
            src="https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/divider-2.webp"
            alt="divider"
            sx={{ width: { xs: "100%", sm: "496px" }, height: "7px" }}
          />

          <Box sx={{ maxWidth: { md: "960px" }, margin: "auto" }}>
            <Box
              sx={{
                fontWeight: "300",
                fontSize: { xs: "16px", sm: "18px" },
                lineHeight: { xs: "24px", sm: "32px" },
                color: "#404456",
                mt: { xs: 2, md: 4 },
              }}
            >
              {contactUaeText.banner.description}
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}
